<button #originRef (click)="showPopover()" [class.bg-hover]="dropdownOpen" class="button" mat-icon-button type="button">
  <mat-icon
    [matBadgeHidden]="(numNotifications$ | async) > 0 ? false : true"
    color="primary"
    class="primary-icon"
    [matBadge]="numNotifications$ | async"
    matBadgeSize="small"
    matBadgeColor="warn"
    svgIcon="mat:notifications_active"
    [@shake]="animState"
  ></mat-icon>
</button>
